import React, { Fragment, useEffect } from "react";
import PropTypes from 'prop-types'
import { WallBackground } from './theme'
import {
  scaleBackgroundHeight,
  scaleBackgroundWidth,
  scalePositionX,
  scalePositionY
} from "../PreviewProduct/themeHelpers";
import MeasureBackground from "../../containers/MeasureBackground";

const actionOnlyOnElement = action => e => {
  e.preventDefault()
  if (e.target === e.currentTarget) {
    action()
  }
}


function calcBg(isFull, rest, ref ) {
  const {width, height} = ref.current.getBoundingClientRect()

  const px = scalePositionX({w: width, ...rest})
  const py = scalePositionY({h: height, ...rest})
  const sw = scaleBackgroundWidth({w: width, ...rest})
  const sh = scaleBackgroundHeight({h: height, ...rest})

  return {height, width, px, py, sw, sh}
}

const Background = ({ children, onClick, isFull, updateDim, ...rest }) => {
  const ref = React.useRef()
  const wrapperRef = React.useRef()
  const [posX, setPosX] = React.useState()
  const [posy, setPosY] = React.useState()
  const [size, setSize] = React.useState()
  const [height, setHeight] = React.useState('100%')
  const [width, setWidth] = React.useState('100%')
  const [aspect, setAspect] = React.useState(false)

  function bg(){

    if(wrapperRef.current) {
      const {width: w, height: h} = wrapperRef.current.getBoundingClientRect()

      setAspect(w / h < 1.5)


      if (!aspect) {
        setWidth(h * 1.5 + 'px')
        setHeight('100%')
      } else {
        setWidth('100%')
        setHeight(w / 1.5 + 'px')
      }

      const {height, width, px, py, sh, sw} = calcBg(isFull, rest, ref)

      updateDim(height, width)

      setPosX(px === 0 ? 'center' : px + 'px')
      setPosY(py === 0 ? 'center' : py + 'px')
      setSize(((sw !== w) || (sh !== h)) ? `${sw}px ${sh}px` : '100%')
    }
  }

  useEffect(() => {
    bg()
  })

  useEffect(() => {
    setTimeout(() => bg(), 250);
  }, [isFull])

  useEffect(() => {
    window.addEventListener('resize', bg)
    return () => window.removeEventListener('resize', bg)
  })

  return <div
    ref={wrapperRef}
    style={{
    display: 'flex',
    height: '100%',
    width: `calc(100% - ${isFull? '0%':'20%'})`,
    left: isFull? '0': '20%',
    position: "absolute",
    justifyContent: 'center',
    alignItems: 'center',
    transition: '.40s ease-in-out'
  }}>
    <MeasureBackground />
  <WallBackground isFull={isFull} width={width} height={height} size={size} posX={posX} posY={posy} innerRef={ref} id={'wall-app'} onClick={actionOnlyOnElement(onClick)} {...rest}>
    {children}
  </WallBackground>
  </div>
}

Background.propTypes = {
  src: PropTypes.string,
  isFull: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  crop: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
}

export default Background



// WEBPACK FOOTER //
// ./src/components/WallBackground/index.js